import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ErrorKind = 'generic' | 'rate-limit';

export interface ErrorDetail {
  kind: ErrorKind;
  // Segundos sugeridos por el servidor (Retry-After) antes de reintentar.
  retryAfterSeconds?: number;
}

@Injectable({ providedIn: 'root' })
export class ErrorStateService {
  private _isError$ = new BehaviorSubject<boolean>(false);
  isError$ = this._isError$.asObservable();

  private _errorDetail$ = new BehaviorSubject<ErrorDetail>({ kind: 'generic' });
  errorDetail$ = this._errorDetail$.asObservable();

  setError(value: boolean, detail: ErrorDetail = { kind: 'generic' }) {
    this._errorDetail$.next(value ? detail : { kind: 'generic' });
    this._isError$.next(value);
  }
}

@Injectable({ providedIn: 'root' })
export class LoadingStateService {
  private _isLoading$ = new BehaviorSubject<boolean>(true);
  isLoading$ = this._isLoading$.asObservable();

  private _isOverlayActive$ = new BehaviorSubject<boolean>(false);
  isOverlayActive$ = this._isOverlayActive$.asObservable();

  setLoading(value: boolean) {
    this._isLoading$.next(value);
  }

  setOverlayActive(value: boolean) {
    this._isOverlayActive$.next(value);
  }
}
